webpackJsonp([0],{

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.listenToAuth = exports.getRedirectResult = exports.signOut = exports.signInWithGoogle = exports.signInWithFacebook = exports.signInAnonymously = exports.showSignIn = exports.hideSignIn = exports.updateUser = undefined;

var _reduxActions = __webpack_require__(34);

var _AuthService = __webpack_require__(118);

var _AuthService2 = _interopRequireDefault(_AuthService);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = new _AuthService2.default();

var updateUser = exports.updateUser = (0, _reduxActions.createAction)(_types2.default.USER_UPDATED);

var hideSignIn = exports.hideSignIn = (0, _reduxActions.createAction)(_types2.default.SIGN_IN_HIDE);
var showSignIn = exports.showSignIn = (0, _reduxActions.createAction)(_types2.default.SIGN_IN_SHOW);

var signInAnonymously = exports.signInAnonymously = (0, _reduxActions.createAction)(_types2.default.SIGN_IN, function () {
	return service.signInAnonymously();
});

var signInWithFacebook = exports.signInWithFacebook = (0, _reduxActions.createAction)(_types2.default.SIGN_IN, function () {
	return service.signInWithFacebook();
});

var signInWithGoogle = exports.signInWithGoogle = (0, _reduxActions.createAction)(_types2.default.SIGN_IN, function () {
	return service.signInWithGoogle();
});

var signOut = exports.signOut = (0, _reduxActions.createAction)(_types2.default.SIGN_OUT, function () {
	return service.signOut();
});

var getRedirectResult = exports.getRedirectResult = (0, _reduxActions.createAction)(_types2.default.SIGN_IN_RESULT, function () {
	return service.getRedirectResult();
});

var listenToAuth = exports.listenToAuth = function listenToAuth() {
	return function (dispatch) {
		service.listenToAuth(function (user) {
			if (user) {
				dispatch(updateUser(user));
			} else {
				dispatch(updateUser(null));
			}
		});
	};
};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthService = function () {
	function AuthService() {
		_classCallCheck(this, AuthService);

		this.auth = firebase.auth();
		this.ref = firebase.database().ref();
	}

	_createClass(AuthService, [{
		key: 'getOrCreateUser',
		value: function getOrCreateUser() {
			return Promise.resolve(this.currentUser || this.signInAnonymously());
		}
	}, {
		key: 'listenToAuth',
		value: function listenToAuth(callback) {
			return this.auth.onAuthStateChanged(callback);
		}
	}, {
		key: 'getRedirectResult',
		value: function getRedirectResult() {
			var _this = this;

			return this.auth.getRedirectResult().then(function (result) {
				if (result.credential) {
					var token = result.credential.accessToken;
					console.log('getRedirectResult.token', token);
				}
			}).catch(function (error) {
				if (error.code === 'auth/credential-already-in-use') {
					return _this.auth.signInWithCredential(error.credential);
				}
				throw error;
			});
		}
	}, {
		key: 'signInAnonymously',
		value: function signInAnonymously() {
			return this.auth.signInAnonymously();
		}
	}, {
		key: 'signInWithProvider',
		value: function signInWithProvider(provider) {
			var currentUser = this.auth.currentUser;

			if (currentUser && currentUser.isAnonymous) {
				currentUser.linkWithRedirect(provider);
			} else {
				this.auth.signInWithRedirect(provider);
			}
		}
	}, {
		key: 'signInWithFacebook',
		value: function signInWithFacebook() {
			var provider = new firebase.auth.FacebookAuthProvider();
			this.signInWithProvider(provider);
		}
	}, {
		key: 'signInWithGoogle',
		value: function signInWithGoogle() {
			var provider = new firebase.auth.GoogleAuthProvider();
			this.signInWithProvider(provider);
		}
	}, {
		key: 'signOut',
		value: function signOut() {
			return this.auth.signOut();
		}
	}, {
		key: 'currentUser',
		get: function get() {
			return this.auth.currentUser;
		}
	}]);

	return AuthService;
}();

exports.default = AuthService;

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Main;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Install = __webpack_require__(141);

var _Install2 = _interopRequireDefault(_Install);

__webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Main() {
	document.title = 'Sendpoll';

	return _react2.default.createElement(_Install2.default, null);
}

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Install;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _logo = __webpack_require__(142);

var _logo2 = _interopRequireDefault(_logo);

__webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Install() {
	if (!/iPad|iPhone/.test(navigator.userAgent)) {
		return null;
	}

	return _react2.default.createElement(
		'div',
		{ className: 'install-bar' },
		_react2.default.createElement(
			'div',
			{ className: 'left' },
			_react2.default.createElement('img', { className: 'logo', src: _logo2.default, alt: 'Sendpoll' })
		),
		_react2.default.createElement(
			'div',
			{ className: 'text' },
			_react2.default.createElement(
				'div',
				{ className: 'title' },
				'Sendpoll'
			),
			_react2.default.createElement(
				'div',
				{ className: 'body' },
				'Install to your home screen'
			)
		),
		_react2.default.createElement(
			'div',
			{ className: 'right' },
			_react2.default.createElement(
				'a',
				{ className: 'btn btn-default', href: '#install' },
				'Install'
			)
		)
	);
}

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/logo-8320f6.svg";

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _runtime = __webpack_require__(247);

var _runtime2 = _interopRequireDefault(_runtime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* global ga Raven */


if (true) {
	_runtime2.default.install({
		onUpdateReady: function onUpdateReady() {
			return _runtime2.default.applyUpdate();
		},
		onUpdated: function onUpdated() {
			return window.location.reload();
		}
	});

	Raven.config({"facebook":"1308684189194545","analytics":"UA-88910082-1","sentry":"https://bc46ef7cef124a6cae92216ca285790a@sentry.io/122103"}.sentry).install();
}

var dimensions = {
	VIEW_MODE: 'dimension1'
};

var metrics = {
	RESPONSE_END_TIME: 'metric1',
	DOM_LOAD_TIME: 'metric2',
	WINDOW_LOAD_TIME: 'metric3'
};

window.ga = window.ga || function () {
	for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		args[_key] = arguments[_key];
	}

	return (ga.q = ga.q || []).push(args);
};
ga('create', {"facebook":"1308684189194545","analytics":"UA-88910082-1","sentry":"https://bc46ef7cef124a6cae92216ca285790a@sentry.io/122103"}.analytics, 'auto');
ga('set', 'transport', 'beacon');
ga('send', 'pageview');

if (navigator.standalone) {
	ga('set', dimensions.VIEW_MODE, 'Home Screen');
}

var sendNavigationTimingMetrics = function sendNavigationTimingMetrics() {
	// Only track performance in supporting browsers.
	if (!(window.performance && window.performance.timing)) return;

	// If the window hasn't loaded, run this function after the `load` event.
	if (document.readyState !== 'complete') {
		window.addEventListener('load', sendNavigationTimingMetrics);
		return;
	}

	var nt = performance.timing;
	var navStart = nt.navigationStart;

	var responseEnd = Math.round(nt.responseEnd - navStart);
	var domLoaded = Math.round(nt.domContentLoadedEventStart - navStart);
	var windowLoaded = Math.round(nt.loadEventStart - navStart);

	// In some edge cases browsers return very obviously incorrect NT values,
	// e.g. 0, negative, or future times. This validates values before sending.
	var allValuesAreValid = function allValuesAreValid() {
		for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			values[_key2] = arguments[_key2];
		}

		return values.every(function (value) {
			return value > 0 && value < 1e6;
		});
	};

	if (allValuesAreValid(responseEnd, domLoaded, windowLoaded)) {
		var _ga;

		ga('send', 'event', (_ga = {
			eventCategory: 'Navigation Timing',
			eventAction: 'track',
			nonInteraction: true
		}, _defineProperty(_ga, metrics.RESPONSE_END_TIME, responseEnd), _defineProperty(_ga, metrics.DOM_LOAD_TIME, domLoaded), _defineProperty(_ga, metrics.WINDOW_LOAD_TIME, windowLoaded), _ga));
	}
};

sendNavigationTimingMetrics();

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reduce = Function.bind.call(Function.call, Array.prototype.reduce);
var isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
var concat = Function.bind.call(Function.call, Array.prototype.concat);
var keys = Reflect.ownKeys;

if (!Object.values) {
	Object.values = function values(O) {
		return reduce(keys(O), function (v, k) {
			return concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []);
		}, []);
	};
}

if (!Object.entries) {
	Object.entries = function entries(O) {
		return reduce(keys(O), function (e, k) {
			return concat(e, typeof k === 'string' && isEnumerable(O, k) ? [[k, O[k]]] : []);
		}, []);
	};
}

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.listenForResults = listenForResults;

var _ResultsService = __webpack_require__(190);

var _ResultsService2 = _interopRequireDefault(_ResultsService);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = new _ResultsService2.default();

function listenForResults(pollId) {
	return function (dispatch, getState) {
		if (pollId in getState().results) return;

		service.listen(pollId, function (results) {
			dispatch({
				type: _types2.default.RESULTS_UPDATED,
				payload: { pollId: pollId, results: results }
			});
		});
	};
}

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResultsService = function () {
	function ResultsService() {
		_classCallCheck(this, ResultsService);

		this.auth = firebase.auth();
		this.ref = firebase.database().ref();
		this.resultsRef = this.ref.child('results');
	}

	_createClass(ResultsService, [{
		key: 'get',
		value: function get(pollId) {
			return this.resultsRef.child(pollId).once('value').then(function (snap) {
				return snap.value();
			});
		}
	}, {
		key: 'listen',
		value: function listen(pollId, callback) {
			var ref = this.resultsRef.child(pollId);

			ref.off();
			ref.on('value', function (snap) {
				return callback(snap.val());
			});

			return function () {
				return ref.off();
			};
		}
	}, {
		key: 'update',
		value: function update(pollId, add, subtract) {
			return this.resultsRef.child(pollId).transaction(function (current) {
				if (current === null) {
					return _defineProperty({}, add, 1);
				}

				var result = Object.assign({}, current);

				if (Number.isInteger(add) && add >= 0) {
					result[add] = (result[add] || 0) + 1;
				}
				if (Number.isInteger(subtract) && subtract >= 0) {
					result[subtract] = result[subtract] >= 0 ? result[subtract] - 1 : 0;
				}

				return result;
			});
		}
	}]);

	return ResultsService;
}();

exports.default = ResultsService;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Splash;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Splash() {
	return _react2.default.createElement("div", { className: "splash" });
}

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.values = undefined;
exports.autocomplete = autocomplete;
exports.predict = predict;

var _capitalize = __webpack_require__(238);

var _capitalize2 = _interopRequireDefault(_capitalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = exports.values = ['Yes', 'No'];

function autocomplete() {
	return values;
}

function predict(string) {
	var words = string.trim().toLowerCase().split(' ');
	var index = values.indexOf((0, _capitalize2.default)(words[0]));

	if (index > -1) {
		return [words[0] === 'yes' ? values[1] : values[0]];
	}

	return [];
}

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = capitalize;
function capitalize(string) {
	var first = string.substr(0, 1).toUpperCase();
	var rest = string.substring(1).toLowerCase();

	return "" + first + rest;
}

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.weekdays = undefined;
exports.autocomplete = autocomplete;
exports.predict = predict;

var _capitalize = __webpack_require__(238);

var _capitalize2 = _interopRequireDefault(_capitalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var weekdays = exports.weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function autocomplete() {
	var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

	var day = new Date().getDay() + 1;

	return [].concat(_toConsumableArray(Array(limit))).map(function (v, i) {
		return weekdays[(day + i) % 7];
	});
}

function predict(string) {
	var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

	var words = string.trim().toLowerCase().split(' ');
	var index = weekdays.indexOf((0, _capitalize2.default)(words[0]));

	if (index > -1) {
		return [].concat(_toConsumableArray(Array(limit))).map(function (v, i) {
			return weekdays[(index + i + 1) % 7];
		});
	}

	return [];
}

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.autocomplete = autocomplete;
exports.predict = predict;
function autocomplete() {
	return ['1', '2'];
}

function predict(string) {
	var words = string.trim().toLowerCase().split(' ');
	var number = Number(words[0]);

	if (words[0] && !Number.isNaN(number)) {
		return [String(number + 1)];
	}

	return [];
}

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = plural;
function plural(number, word) {
	return number === 1 ? number + " " + word : number + " " + word + "s";
}

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(250);


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactHotLoader = __webpack_require__(178);

var _reactTapEventPlugin = __webpack_require__(344);

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _AppService = __webpack_require__(350);

var _AppService2 = _interopRequireDefault(_AppService);

var _Root = __webpack_require__(386);

var _Root2 = _interopRequireDefault(_Root);

__webpack_require__(144);

__webpack_require__(145);

__webpack_require__(248);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactTapEventPlugin2.default)();

var app = new _AppService2.default();
var store = app.store,
    history = app.history;


_reactDom2.default.render(_react2.default.createElement(
	_reactHotLoader.AppContainer,
	null,
	_react2.default.createElement(_Root2.default, { store: store, history: history })
), document.getElementById('root'));

if (false) {
	module.hot.accept('./components/Root', function () {
		// eslint-disable-next-line global-require
		var NewRoot = require('./components/Root').default;
		_reactDom2.default.render(_react2.default.createElement(
			_reactHotLoader.AppContainer,
			null,
			_react2.default.createElement(NewRoot, { store: store, history: history })
		), document.getElementById('root'));
	});
}

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	POLL_CREATE: 'POLL_CREATE',
	POLL_REMOVE: 'POLL_REMOVE',
	POLL_UPDATE: 'POLL_UPDATE',
	POLL_UPDATED: 'POLL_UPDATED',
	RESULTS_UPDATED: 'RESULTS_UPDATED',
	SIGN_IN_HIDE: 'SIGN_IN_HIDE',
	SIGN_IN_SHOW: 'SIGN_IN_SHOW',
	SIGN_IN: 'SIGN_IN',
	SIGN_IN_RESULT: 'SIGN_IN_RESULT',
	SIGN_OUT: 'SIGN_OUT',
	USER_UPDATED: 'USER_UPDATED',
	VOTE_CAST: 'VOTE_CAST',
	VOTE_READ: 'VOTE_READ'
};

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Poll = function () {
	function Poll(snapshot) {
		_classCallCheck(this, Poll);

		if (snapshot) {
			this.key = snapshot.key;
			Object.assign(this, snapshot.val());
		}
	}

	_createClass(Poll, [{
		key: "url",
		get: function get() {
			return "https://sendpoll.com/" + this.key;
		}
	}]);

	return Poll;
}();

exports.default = Poll;

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRouter = __webpack_require__(23);

var _reactRouterRedux = __webpack_require__(183);

var _auth = __webpack_require__(116);

var _user = __webpack_require__(365);

var _store = __webpack_require__(368);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppService = function AppService() {
	var _this = this;

	_classCallCheck(this, AppService);

	this.store = (0, _store2.default)();
	this.history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, this.store);

	this.store.subscribe(function () {
		var _store$getState = _this.store.getState(),
		    newUser = _store$getState.user;

		if (_this.user !== newUser) {
			_this.user = newUser;
			if (_this.user) {
				_this.store.dispatch((0, _user.listenForPolls)());
			}
		}
	});

	this.store.dispatch((0, _auth.getRedirectResult)());
	this.store.dispatch((0, _auth.listenToAuth)());
};

exports.default = AppService;

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.listenForPolls = listenForPolls;

var _reduxActions = __webpack_require__(34);

var _UserService = __webpack_require__(366);

var _UserService2 = _interopRequireDefault(_UserService);

var _poll = __webpack_require__(63);

var _results = __webpack_require__(189);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = new _UserService2.default();

function listenForPolls() {
	return function (dispatch) {
		service.listenForPollIds(function (pollId) {
			dispatch((0, _poll.listenForPoll)(pollId));
			dispatch((0, _results.listenForResults)(pollId));
		});
	};
}

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserService = function () {
	function UserService() {
		_classCallCheck(this, UserService);

		this.auth = firebase.auth();
		this.ref = firebase.database().ref();
		this.usersRef = this.ref.child('users');
	}

	_createClass(UserService, [{
		key: 'listenForPollIds',
		value: function listenForPollIds(callback) {
			var uid = this.auth.currentUser.uid;

			var ref = this.usersRef.child(uid).child('polls');

			ref.off();
			ref.on('child_added', function (snap) {
				return callback(snap.key);
			});

			return function () {
				return ref.off();
			};
		}
	}]);

	return UserService;
}();

exports.default = UserService;

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AuthService = __webpack_require__(118);

var _AuthService2 = _interopRequireDefault(_AuthService);

var _Poll = __webpack_require__(35);

var _Poll2 = _interopRequireDefault(_Poll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ts = firebase.database.ServerValue.TIMESTAMP;

var PollService = function () {
	function PollService() {
		_classCallCheck(this, PollService);

		this.auth = new _AuthService2.default();
		this.ref = firebase.database().ref();
		this.pollsRef = this.ref.child('polls');
		this.resultsRef = this.ref.child('results');
		this.usersRef = this.ref.child('users');
		this.votesRef = this.ref.child('votes');
	}

	_createClass(PollService, [{
		key: 'create',
		value: function create(data) {
			var _this = this;

			var pollRef = this.pollsRef.push();
			var pollKey = pollRef.key;

			return this.auth.getOrCreateUser().then(function (_ref) {
				var _this$ref$update;

				var uid = _ref.uid;
				return _this.ref.update((_this$ref$update = {}, _defineProperty(_this$ref$update, 'polls/' + pollKey, Object.assign({}, data, { ts: ts, uid: uid })), _defineProperty(_this$ref$update, 'results/' + pollKey, data.options.map(function () {
					return 0;
				})), _defineProperty(_this$ref$update, 'users/' + uid + '/polls/' + pollKey, ts), _this$ref$update)).then(function () {
					return pollKey;
				});
			});
		}
	}, {
		key: 'remove',
		value: function remove(id) {
			var uid = this.auth.currentUser.uid;


			return Promise.all([this.votesRef.child(id).remove(), this.resultsRef.child(id).remove(), this.usersRef.child(uid).child('polls').child(id).remove(), this.pollsRef.child(id).remove()]);
		}
	}, {
		key: 'listen',
		value: function listen(pollId, callback) {
			var ref = this.pollsRef.child(pollId);

			ref.off();
			ref.on('value', function (snap) {
				return callback({
					pollId: pollId,
					poll: snap.exists() ? new _Poll2.default(snap) : null
				});
			});

			return function () {
				return ref.off();
			};
		}
	}, {
		key: 'update',
		value: function update(pollId, values) {
			return this.pollsRef.child(pollId).update(values);
		}
	}]);

	return PollService;
}();

exports.default = PollService;

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(119);

var _reduxPromise = __webpack_require__(372);

var _reduxPromise2 = _interopRequireDefault(_reduxPromise);

var _reduxThunk = __webpack_require__(378);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _analytics = __webpack_require__(379);

var _analytics2 = _interopRequireDefault(_analytics);

var _reducers = __webpack_require__(380);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middleware = [_reduxThunk2.default, _reduxPromise2.default, _analytics2.default];

if (false) {
	// eslint-disable-next-line global-require
	var _require = require('redux-logger'),
	    logger = _require.logger;

	middleware.push(logger);
}

function configureStore(initialState) {
	return (0, _redux.createStore)(_reducers2.default, _redux.applyMiddleware.apply(undefined, middleware), initialState);
}

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nonInteraction = true; /* global ga */

exports.default = function (store) {
	return function (next) {
		return function (action) {
			switch (action.type) {
				case _types2.default.USER_UPDATED:
					if (action.payload) {
						ga('set', 'userId', action.payload.key);
					}
					break;
				case _types2.default.POLL_CREATE:
					ga('send', 'event', 'Poll', 'Created');
					break;
				case _types2.default.POLL_REMOVE:
					ga('send', 'event', 'Poll', 'Removed');
					break;
				case _types2.default.VOTE_CAST:
					ga('send', 'event', 'Vote', 'Cast');
					break;
				default:
					break;
			}

			return next(action);
		};
	};
};

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = __webpack_require__(119);

var _reactRouterRedux = __webpack_require__(183);

var _app = __webpack_require__(381);

var _app2 = _interopRequireDefault(_app);

var _polls = __webpack_require__(382);

var _polls2 = _interopRequireDefault(_polls);

var _results = __webpack_require__(383);

var _results2 = _interopRequireDefault(_results);

var _user = __webpack_require__(384);

var _user2 = _interopRequireDefault(_user);

var _vote = __webpack_require__(385);

var _vote2 = _interopRequireDefault(_vote);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appReducer = (0, _redux.combineReducers)({
	app: _app2.default,
	polls: _polls2.default,
	results: _results2.default,
	routing: _reactRouterRedux.routerReducer,
	user: _user2.default,
	vote: _vote2.default
});

exports.default = function (state, action) {
	if ([_types2.default.SIGN_OUT, _types2.default.USER_UPDATED].includes(action.type)) {
		return appReducer(undefined, action);
	}

	return appReducer(state, action);
};

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.defaultState = undefined;

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(34);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = exports.defaultState = Object.freeze({
	authPending: true,
	showSignIn: false
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _types2.default.SIGN_IN_HIDE, function (state) {
	return _extends({}, state, { showSignIn: false });
}), _defineProperty(_handleActions, _types2.default.SIGN_IN_SHOW, function (state) {
	return _extends({}, state, { showSignIn: true });
}), _defineProperty(_handleActions, _types2.default.USER_UPDATED, function (state) {
	return _extends({}, state, { authPending: false });
}), _handleActions), defaultState);

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.defaultState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(34);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = exports.defaultState = {};

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, _types2.default.POLL_UPDATED, function (state, _ref) {
	var payload = _ref.payload;

	if (payload.poll) {
		return _extends({}, state, _defineProperty({}, payload.pollId, payload.poll));
	}
	var newState = _extends({}, state);
	delete newState[payload.pollId];
	return newState;
}), defaultState);

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.defaultState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(34);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = exports.defaultState = {};

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, _types2.default.RESULTS_UPDATED, function (state, _ref) {
	var payload = _ref.payload;

	if (payload.results) {
		return _extends({}, state, _defineProperty({}, payload.pollId, payload.results));
	}
	var newState = _extends({}, state);
	delete newState[payload.pollId];
	return newState;
}), defaultState);

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.defaultState = undefined;

var _reduxActions = __webpack_require__(34);

var _auth = __webpack_require__(116);

var defaultState = exports.defaultState = null;

exports.default = (0, _reduxActions.handleAction)(_auth.updateUser, {
	next: function next(state, action) {
		return action.payload;
	}
}, defaultState);

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.defaultState = undefined;

var _reduxActions = __webpack_require__(34);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = exports.defaultState = null;

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, _types2.default.VOTE_READ, function (state, action) {
	return action.payload;
}), defaultState);

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Root;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(36);

var _reactRouter = __webpack_require__(23);

var _routes = __webpack_require__(387);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Root(props) {
	return _react2.default.createElement(
		_reactRedux.Provider,
		{ store: props.store },
		_react2.default.createElement(_reactRouter.Router, { history: props.history, routes: _routes2.default })
	);
} /* eslint-disable react/forbid-prop-types */


Root.propTypes = {
	store: _propTypes2.default.object.isRequired,
	history: _propTypes2.default.object.isRequired
};

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(23);

var _App = __webpack_require__(388);

var _App2 = _interopRequireDefault(_App);

var _Auth = __webpack_require__(478);

var _Auth2 = _interopRequireDefault(_Auth);

var _Container = __webpack_require__(479);

var _Container2 = _interopRequireDefault(_Container);

var _Main = __webpack_require__(140);

var _Main2 = _interopRequireDefault(_Main);

var _NotFound = __webpack_require__(556);

var _NotFound2 = _interopRequireDefault(_NotFound);

var _Container3 = __webpack_require__(559);

var _Container4 = _interopRequireDefault(_Container3);

var _Container5 = __webpack_require__(570);

var _Container6 = _interopRequireDefault(_Container5);

var _Container7 = __webpack_require__(582);

var _Container8 = _interopRequireDefault(_Container7);

var _Container9 = __webpack_require__(588);

var _Container10 = _interopRequireDefault(_Container9);

var _Container11 = __webpack_require__(592);

var _Container12 = _interopRequireDefault(_Container11);

var _Success = __webpack_require__(602);

var _Success2 = _interopRequireDefault(_Success);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createElement(
	_reactRouter.Route,
	{ path: '/', component: _App2.default },
	_react2.default.createElement(_reactRouter.IndexRoute, { component: _Main2.default }),
	_react2.default.createElement(
		_reactRouter.Route,
		{ component: _Auth2.default },
		_react2.default.createElement(_reactRouter.Route, { path: '/create', component: _Container2.default }),
		_react2.default.createElement(_reactRouter.Route, { path: '/polls', component: _Container4.default }),
		_react2.default.createElement(_reactRouter.Route, { path: '/:pollId/results', component: _Container6.default }),
		_react2.default.createElement(_reactRouter.Route, { path: '/:pollId/send', component: _Container8.default }),
		_react2.default.createElement(_reactRouter.Route, { path: '/:pollId/vote/success', component: _Success2.default }),
		_react2.default.createElement(_reactRouter.Route, { path: '/:pollId', component: _Container12.default }),
		_react2.default.createElement(_reactRouter.Route, { path: '/:pollId/settings', component: _Container10.default })
	),
	_react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFound2.default })
);

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = App;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsCssTransitionGroup = __webpack_require__(389);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _colors = __webpack_require__(73);

var _getMuiTheme = __webpack_require__(195);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

var _MuiThemeProvider = __webpack_require__(449);

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var theme = (0, _getMuiTheme2.default)({
	palette: {
		primary1Color: _colors.orangeA700,
		primary2Color: _colors.amberA400,
		accent1Color: _colors.lightBlue600
	},
	appBar: {
		color: _colors.amberA700
	}
});

function App(_ref) {
	var children = _ref.children,
	    location = _ref.location;

	var transition = location.action === 'POP' ? 'reversePageSwap' : 'pageSwap';

	return _react2.default.createElement(
		_MuiThemeProvider2.default,
		{ muiTheme: theme },
		_react2.default.createElement(
			_reactAddonsCssTransitionGroup2.default,
			{
				component: 'div',
				transitionName: transition,
				transitionEnterTimeout: 500,
				transitionLeaveTimeout: 500
			},
			_react2.default.cloneElement(children, { key: location.pathname })
		)
	);
}

App.propTypes = {
	children: _propTypes2.default.node,
	location: _propTypes2.default.shape({
		action: _propTypes2.default.string
	})
};

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(36);

var _Splash = __webpack_require__(215);

var _Splash2 = _interopRequireDefault(_Splash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Auth(_ref) {
	var authPending = _ref.authPending,
	    children = _ref.children;

	if (authPending) {
		return _react2.default.createElement(_Splash2.default, null);
	}

	return children;
}

Auth.propTypes = {
	children: _propTypes2.default.node,
	authPending: _propTypes2.default.bool.isRequired
};

Auth.defaultProps = {
	children: null
};

var mapStateToProps = function mapStateToProps(_ref2) {
	var app = _ref2.app;
	return {
		authPending: app.authPending
	};
};

var Container = (0, _reactRedux.connect)(mapStateToProps)(Auth);

exports.default = Container;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = __webpack_require__(36);

var _Create = __webpack_require__(480);

var _Create2 = _interopRequireDefault(_Create);

var _poll = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref) {
	var polls = _ref.polls;
	return {
		polls: Object.values(polls)
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		submit: function submit(data) {
			dispatch((0, _poll.createPoll)(data));
		}
	};
};

var Container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Create2.default);

exports.default = Container;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AutoComplete = __webpack_require__(481);

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

var _RaisedButton = __webpack_require__(234);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _Page = __webpack_require__(52);

var _Page2 = _interopRequireDefault(_Page);

var _Options = __webpack_require__(546);

var _Options2 = _interopRequireDefault(_Options);

var _Poll = __webpack_require__(35);

var _Poll2 = _interopRequireDefault(_Poll);

var _question = __webpack_require__(551);

var _question2 = _interopRequireDefault(_question);

__webpack_require__(552);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var meta = {
	title: 'Create poll',
	description: 'Create your own poll with any question you like and easily send it to people.'
};

var Create = function (_React$Component) {
	_inherits(Create, _React$Component);

	function Create(props) {
		_classCallCheck(this, Create);

		var _this = _possibleConstructorReturn(this, (Create.__proto__ || Object.getPrototypeOf(Create)).call(this, props));

		_this.state = {
			question: ''
		};

		_this.handleChange = function (question) {
			var index = _this.state.questions.indexOf(question);
			var options = index > -1 ? _this.props.polls[index].options : (0, _question2.default)(question);

			_this.setState({
				options: options,
				question: question
			});
		};

		_this.handleSubmit = function (event) {
			event.preventDefault();
			if (_this.refOptions.validate()) {
				_this.props.submit({
					question: _this.state.question,
					options: _this.refOptions.getValues()
				});
			}
		};
		return _this;
	}

	_createClass(Create, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.update(this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.update(nextProps);
		}
	}, {
		key: 'update',
		value: function update(_ref) {
			var polls = _ref.polls;

			this.setState({
				optionsHistory: polls.map(function (_ref2) {
					var options = _ref2.options;
					return options;
				}),
				questions: polls.map(function (_ref3) {
					var question = _ref3.question;
					return question;
				})
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Page2.default,
				_extends({ className: 'create' }, meta, { showBack: true }),
				_react2.default.createElement(
					'form',
					{ onSubmit: this.handleSubmit },
					_react2.default.createElement(_AutoComplete2.default, {
						dataSource: this.state.questions,
						filter: _AutoComplete2.default.fuzzyFilter,
						floatingLabelText: 'What do you want to ask?',
						fullWidth: true,
						maxSearchResults: 5,
						onFocus: function onFocus(event) {
							return event.target.select();
						},
						onUpdateInput: this.handleChange,
						required: true,
						value: this.state.question
					}),
					_react2.default.createElement(_Options2.default, {
						history: this.state.optionsHistory,
						predictions: this.state.options,
						ref: function ref(elm) {
							return _this2.refOptions = elm;
						}
					}),
					_react2.default.createElement(
						'div',
						{ className: 'actions' },
						_react2.default.createElement(_RaisedButton2.default, { label: 'Send Poll\u2026', primary: true, type: 'submit' })
					)
				)
			);
		}
	}]);

	return Create;
}(_react2.default.Component);

exports.default = Create;


Create.propTypes = {
	polls: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_Poll2.default)),
	submit: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Page;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(23);

var _reactHelmet = __webpack_require__(521);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _AppBar = __webpack_require__(529);

var _AppBar2 = _interopRequireDefault(_AppBar);

var _IconButton = __webpack_require__(139);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _arrowBack = __webpack_require__(532);

var _arrowBack2 = _interopRequireDefault(_arrowBack);

var _Container = __webpack_require__(533);

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Page(props) {
	return _react2.default.createElement(
		'div',
		{ className: 'page ' + props.className },
		_react2.default.createElement(_reactHelmet2.default, {
			title: props.pageTitle || props.title,
			meta: [{ name: 'description', content: props.description }]
		}),
		_react2.default.createElement(_AppBar2.default, {
			className: 'header',
			iconElementLeft: _react2.default.createElement(
				_IconButton2.default,
				null,
				_react2.default.createElement(_arrowBack2.default, null)
			),
			iconElementRight: _react2.default.createElement(_Container2.default, null),
			iconStyleRight: { marginTop: '14px' },
			onLeftIconButtonTouchTap: function onLeftIconButtonTouchTap() {
				return _reactRouter.browserHistory.goBack();
			},
			showMenuIconButton: !!props.showBack,
			title: props.title,
			titleStyle: props.titleStyle
		}),
		props.masthead,
		_react2.default.createElement(
			'div',
			{ className: 'content' },
			props.children
		)
	);
}

Page.propTypes = {
	children: _propTypes2.default.node,
	className: _propTypes2.default.string,
	description: _propTypes2.default.string,
	masthead: _propTypes2.default.node,
	pageTitle: _propTypes2.default.string,
	showBack: _propTypes2.default.bool,
	title: _propTypes2.default.string,
	titleStyle: _propTypes2.default.object // eslint-disable-line
};

Page.defaultProps = {
	children: null,
	className: '',
	description: null,
	showBack: false,
	title: null,
	titleStyle: null
};

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = __webpack_require__(36);

var _auth = __webpack_require__(116);

var _Login = __webpack_require__(534);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
	return {
		app: state.app,
		user: state.user
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		hide: function hide() {
			dispatch((0, _auth.hideSignIn)());
		},
		show: function show() {
			dispatch((0, _auth.showSignIn)());
		},
		signInAnonymously: function signInAnonymously() {
			dispatch((0, _auth.signInAnonymously)());
			dispatch((0, _auth.hideSignIn)());
		},
		signInWithFacebook: function signInWithFacebook() {
			dispatch((0, _auth.signInWithFacebook)());
			dispatch((0, _auth.hideSignIn)());
		},
		signInWithGoogle: function signInWithGoogle() {
			dispatch((0, _auth.signInWithGoogle)());
			dispatch((0, _auth.hideSignIn)());
		},
		signOut: function signOut() {
			dispatch((0, _auth.signOut)());
		}
	};
};

var Container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Login2.default);

exports.default = Container;

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Login;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dialog = __webpack_require__(236);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _FlatButton = __webpack_require__(69);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _List = __webpack_require__(95);

var _facebook = __webpack_require__(541);

var _facebook2 = _interopRequireDefault(_facebook);

var _google = __webpack_require__(542);

var _google2 = _interopRequireDefault(_google);

__webpack_require__(543);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Login(props) {
	var actions = [_react2.default.createElement(_FlatButton2.default, {
		label: 'Stay anonymous',
		onTouchTap: props.hide
	})];

	return _react2.default.createElement(
		'div',
		{ className: 'login' },
		props.user && !props.user.isAnonymous ? _react2.default.createElement(_FlatButton2.default, { label: 'Sign Out', onClick: props.signOut }) : _react2.default.createElement(_FlatButton2.default, { label: 'Sign In', onClick: props.show }),
		_react2.default.createElement(
			_Dialog2.default,
			{
				title: 'Login',
				actions: actions,
				modal: false,
				open: props.app.showSignIn,
				onRequestClose: props.hide
			},
			_react2.default.createElement(
				'p',
				null,
				'You really should login, it\'s what all the cool kids do.'
			),
			_react2.default.createElement(
				_List.List,
				null,
				_react2.default.createElement(_List.ListItem, {
					leftIcon: _react2.default.createElement('img', { alt: '', src: _facebook2.default }),
					onClick: props.signInWithFacebook,
					primaryText: 'Facebook'
				}),
				_react2.default.createElement(_List.ListItem, {
					leftIcon: _react2.default.createElement('img', { alt: '', src: _google2.default }),
					onClick: props.signInWithGoogle,
					primaryText: 'Google'
				})
			)
		)
	);
}

Login.propTypes = {
	app: _propTypes2.default.shape({
		showSignIn: _propTypes2.default.bool.isRequired
	}).isRequired,
	hide: _propTypes2.default.func.isRequired,
	show: _propTypes2.default.func.isRequired,
	signInAnonymously: _propTypes2.default.func.isRequired,
	signInWithFacebook: _propTypes2.default.func.isRequired,
	signInWithGoogle: _propTypes2.default.func.isRequired,
	signOut: _propTypes2.default.func.isRequired,
	user: _propTypes2.default.shape({
		isAnonymous: _propTypes2.default.bool.isRequired
	})
};

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTcgMnY0aC0yYy0uNjkgMC0xIC44MS0xIDEuNVYxMGgzdjRoLTN2OGgtNHYtOEg3di00aDNWNmE0IDQgMCAwIDEgNC00aDN6Ii8+PC9zdmc+"

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMjEuMzUgMTEuMWgtOS4xN3YyLjczaDYuNTFjLS4zMyAzLjgxLTMuNSA1LjQ0LTYuNSA1LjQ0QzguMzYgMTkuMjcgNSAxNi4yNSA1IDEyYzAtNC4xIDMuMi03LjI3IDcuMi03LjI3IDMuMDkgMCA0LjkgMS45NyA0LjkgMS45N0wxOSA0LjcyUzE2LjU2IDIgMTIuMSAyQzYuNDIgMiAyLjAzIDYuOCAyLjAzIDEyYzAgNS4wNSA0LjEzIDEwIDEwLjIyIDEwIDUuMzUgMCA5LjI1LTMuNjcgOS4yNS05LjA5IDAtMS4xNS0uMTUtMS44MS0uMTUtMS44MXoiLz48L3N2Zz4="

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = __webpack_require__(217);

var _TextField2 = _interopRequireDefault(_TextField);

var _OptionsService = __webpack_require__(547);

var _OptionsService2 = _interopRequireDefault(_OptionsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var Options = function (_React$Component) {
	_inherits(Options, _React$Component);

	function Options(props) {
		_classCallCheck(this, Options);

		var _this = _possibleConstructorReturn(this, (Options.__proto__ || Object.getPrototypeOf(Options)).call(this, props));

		_this.service = new _OptionsService2.default();

		_this.state = {
			errors: [],
			options: []
		};

		_this.handleChange = function (event) {
			var index = Number(event.target.id);
			var value = event.target.value;
			var newState = _this.service.change(index, value);
			_this.setState(newState);
		};
		return _this;
	}

	_createClass(Options, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.update(this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (this.props.history !== nextProps.history) {
				this.service.setPredict(nextProps.history);
			}
			this.update(nextProps);
		}
	}, {
		key: 'getValues',
		value: function getValues(all) {
			var _this2 = this;

			return this.state.options.map(_OptionsService.trim).map(function (v, i) {
				return v || _this2.state.predictions[i];
			}).filter(function (v) {
				return all || !(0, _OptionsService.isEmpty)(v);
			});
		}
	}, {
		key: 'update',
		value: function update(_ref) {
			var predictions = _ref.predictions,
			    values = _ref.values;

			var newState = this.service.update(values, predictions);
			this.setState(newState);
		}
	}, {
		key: 'validate',
		value: function validate() {
			var errors = this.getValues(true).map(function (option, i, arr) {
				if ((0, _OptionsService.isEmpty)(option) && (i < _OptionsService.MIN || i < arr.length - 1)) {
					return 'You must fill out the option';
				}
				return null;
			});
			this.setState({ errors: errors });
			return errors.every(function (error) {
				return !error;
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'options' },
				this.state.options.map(function (option, i, arr) {
					return _react2.default.createElement(
						'div',
						{ className: 'option', key: i },
						_react2.default.createElement(_TextField2.default, {
							errorText: _this3.state.errors[i],
							floatingLabelFixed: i >= _OptionsService.MIN,
							floatingLabelText: 'Answer option ' + (i + 1),
							fullWidth: true,
							id: '' + i,
							onChange: _this3.handleChange,
							onFocus: function onFocus(event) {
								return event.target.select();
							},
							placeholder: i >= _OptionsService.MIN && i === arr.length - 1 ? 'Leave blank if not used' : '',
							value: arr[i] || _this3.state.predictions[i] || ''
						})
					);
				})
			);
		}
	}]);

	return Options;
}(_react2.default.Component);

exports.default = Options;


Options.propTypes = {
	history: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)),
	predictions: _propTypes2.default.arrayOf(_propTypes2.default.string),
	values: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Options.defaultProps = {
	predictions: [],
	values: []
};

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.MAX = exports.MIN = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.trim = trim;
exports.isEmpty = isEmpty;

var _array = __webpack_require__(548);

var _options = __webpack_require__(549);

var _options2 = _interopRequireDefault(_options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MIN = exports.MIN = 2;
var MAX = exports.MAX = 5;

function trim(val) {
	return (val || '').trim();
}

function isEmpty(val) {
	return trim(val).length === 0;
}

var OptionsService = function () {
	function OptionsService() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var predictions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
		var history = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

		_classCallCheck(this, OptionsService);

		this.set(options, predictions);
		this.setPredict(history);
		this.update(options, predictions);
	}

	_createClass(OptionsService, [{
		key: 'change',
		value: function change(index, value) {
			var predictions = this.predictions.slice();
			if (index === 0) {
				var nextPredictions = this.predict(value);
				if (nextPredictions.length) {
					predictions = [''].concat(_toConsumableArray(nextPredictions));
				}
			}
			if (!value.length) {
				predictions[index] = '';
			}

			var options = this.options.map(function (option, i) {
				return i === index ? value : option;
			});
			var merged = (0, _array.assign)(options, predictions);

			if (merged.length >= MIN) {
				(0, _array.trimTail)(merged, MIN);
				if (merged.length < MAX && !isEmpty(merged[merged.length - 1])) {
					merged.push('');
				}
			}

			(0, _array.balance)(merged.length, options);

			return this.set(options, predictions);
		}
	}, {
		key: 'set',
		value: function set(options, predictions) {
			return Object.assign(this, { options: options, predictions: predictions });
		}
	}, {
		key: 'setPredict',
		value: function setPredict() {
			var history = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			this.predict = (0, _options2.default)(history);
		}
	}, {
		key: 'update',
		value: function update() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var predictions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

			var no = Math.max(predictions.length, options.length, MIN - 1) + 1;

			return this.set((0, _array.assign)([].concat(_toConsumableArray(Array(no))).map(function (v, i) {
				return options[i];
			}), this.options), [].concat(_toConsumableArray(Array(no))).map(function (v, i) {
				return predictions[i];
			}));
		}
	}]);

	return OptionsService;
}();

exports.default = OptionsService;

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.assign = assign;
exports.balance = balance;
exports.trimTail = trimTail;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable no-param-reassign */
var isEmpty = function isEmpty(val) {
	return (val || '').trim().length === 0;
};

function assign(a, b) {
	return [].concat(_toConsumableArray(Array(Math.max(a.length, b.length)))).map(function (v, i) {
		return b[i] || a[i];
	});
}

function balance(length, target) {
	if (target.length > length) {
		target.splice(length);
	}
	if (target.length < length) {
		for (var i = 0; i < length; i++) {
			if (!target[i]) target[i] = '';
		}
	}
}

function trimTail(arr) {
	var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

	for (var i = arr.length - 1; i >= min; i--) {
		if (isEmpty(arr[i])) {
			arr.pop();
		} else {
			break;
		}
	}
	return arr;
}

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createPredict;

var _bool = __webpack_require__(237);

var _date = __webpack_require__(239);

var _number = __webpack_require__(240);

var _optionsHistory = __webpack_require__(550);

var _optionsHistory2 = _interopRequireDefault(_optionsHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPredict() {
	var history = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	var engines = [_bool.predict, _date.predict, _number.predict, (0, _optionsHistory2.default)(history)];

	return function () {
		var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		for (var result, i = 0; i < engines.length; i++) {
			result = engines[i](string);

			if (result.length) {
				return result;
			}
		}

		return [];
	};
}

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createPredict;
/* eslint-disable no-param-reassign */
function createPredict() {
	var history = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	var map = history.reduce(function (obj, options) {
		return (obj[options[0].toLowerCase()] = options.slice(1)) && obj;
	}, {});

	return function (string) {
		return map[string.toLowerCase()] || [];
	};
}

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = predict;

var _bool = __webpack_require__(237);

var _date = __webpack_require__(239);

var _number = __webpack_require__(240);

function predict() {
	var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

	var words = string.trim().toLowerCase().split(' ');
	var first = words[0];

	switch (first) {
		case 'how':
			if (words[1] === 'many') {
				return (0, _number.autocomplete)();
			}
			return [];
		case 'should':
			return (0, _bool.autocomplete)();
		case 'when':
			return (0, _date.autocomplete)();
		default:
			return [];
	}
}

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = NotFound;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(557);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound() {
	return _react2.default.createElement(
		'div',
		{ className: 'notfound' },
		_react2.default.createElement(
			'h1',
			null,
			'Not Found'
		)
	);
}
// import { browserHistory } from 'react-router'

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = __webpack_require__(36);

var _Polls = __webpack_require__(560);

var _Polls2 = _interopRequireDefault(_Polls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
	return {
		polls: Object.values(state.polls).sort(function (a, b) {
			return a.ts > b.ts ? -1 : 1;
		}),
		results: state.results
	};
};

var Container = (0, _reactRedux.connect)(mapStateToProps)(_Polls2.default);

exports.default = Container;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Polls;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(23);

var _FloatingActionButton = __webpack_require__(143);

var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);

var _add = __webpack_require__(562);

var _add2 = _interopRequireDefault(_add);

var _Page = __webpack_require__(52);

var _Page2 = _interopRequireDefault(_Page);

var _Poll = __webpack_require__(35);

var _Poll2 = _interopRequireDefault(_Poll);

var _List = __webpack_require__(563);

var _List2 = _interopRequireDefault(_List);

var _Masthead = __webpack_require__(565);

var _Masthead2 = _interopRequireDefault(_Masthead);

__webpack_require__(568);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var meta = {
	title: 'Polls',
	description: 'Create your own poll with any question you like and easily send it to people.'
};

function Polls(props) {
	return _react2.default.createElement(
		_Page2.default,
		_extends({ className: 'polls' }, meta, { masthead: _react2.default.createElement(_Masthead2.default, props) }),
		props.polls.length ? _react2.default.createElement(_List2.default, props) : _react2.default.createElement(
			'p',
			{ className: 'empty' },
			'No polls. Create one?'
		),
		_react2.default.createElement(
			'div',
			{ className: 'actions pinned' },
			_react2.default.createElement(
				_FloatingActionButton2.default,
				{
					onClick: function onClick() {
						return _reactRouter.browserHistory.push('/create');
					}
				},
				_react2.default.createElement(_add2.default, null)
			)
		)
	);
}

Polls.propTypes = {
	polls: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_Poll2.default))
};

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = PollsList;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(23);

var _List = __webpack_require__(95);

var _plural = __webpack_require__(243);

var _plural2 = _interopRequireDefault(_plural);

var _Poll = __webpack_require__(35);

var _Poll2 = _interopRequireDefault(_Poll);

var _time = __webpack_require__(564);

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calcTotal = function calcTotal(results, pollId) {
	return (results[pollId] || []).reduce(function (t, n) {
		return t + n;
	}, 0);
};

function PollsList(_ref) {
	var polls = _ref.polls,
	    results = _ref.results;

	return _react2.default.createElement(
		_List.List,
		null,
		polls.map(function (poll) {
			return _react2.default.createElement(_List.ListItem, {
				key: poll.key,
				onClick: function onClick() {
					return _reactRouter.browserHistory.push('/' + poll.key + '/results');
				},
				primaryText: poll.question,
				secondaryText: _react2.default.createElement(
					'p',
					{ className: 'secondary' },
					_react2.default.createElement(
						'span',
						null,
						(0, _plural2.default)(calcTotal(results, poll.key), 'vote')
					),
					_react2.default.createElement(
						'span',
						{ className: 'date' },
						'created ',
						(0, _time2.default)(poll.ts),
						' ago'
					)
				)
			});
		})
	);
}

PollsList.propTypes = {
	polls: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_Poll2.default)),
	results: _propTypes2.default.object // eslint-disable-line
};

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (timestamp) {
	var date = new Date(timestamp);

	var seconds = Math.floor((new Date() - date) / 1000);

	var interval = Math.floor(seconds / 31536000);

	if (interval >= 1) {
		return interval + " years";
	}
	interval = Math.floor(seconds / 2592000);
	if (interval >= 1) {
		return interval + " months";
	}
	interval = Math.floor(seconds / 86400);
	if (interval >= 1) {
		return interval + " days";
	}
	interval = Math.floor(seconds / 3600);
	if (interval >= 1) {
		return interval + " hours";
	}
	interval = Math.floor(seconds / 60);
	if (interval >= 1) {
		return interval + " minutes";
	}

	return Math.floor(seconds) + " seconds";
};

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Masthead;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Poll = __webpack_require__(35);

var _Poll2 = _interopRequireDefault(_Poll);

__webpack_require__(566);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sum = function sum(result) {
	return result.reduce(function (s, n) {
		return s + n;
	}, 0);
};
var total = function total(results) {
	return Object.keys(results).reduce(function (t, k) {
		return t + sum(results[k]);
	}, 0);
};

function Masthead(props) {
	return _react2.default.createElement(
		'section',
		{ className: 'masthead' },
		_react2.default.createElement(
			'div',
			{ className: 'block polls' },
			_react2.default.createElement(
				'div',
				{ className: 'number' },
				props.polls.length
			),
			_react2.default.createElement(
				'div',
				{ className: 'text' },
				'polls'
			)
		),
		_react2.default.createElement(
			'div',
			{ className: 'block votes' },
			_react2.default.createElement(
				'div',
				{ className: 'number' },
				total(props.results)
			),
			_react2.default.createElement(
				'div',
				{ className: 'text' },
				'votes'
			)
		)
	);
}

Masthead.propTypes = {
	polls: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_Poll2.default)),
	results: _propTypes2.default.object // eslint-disable-line
};

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = __webpack_require__(36);

var _Results = __webpack_require__(571);

var _Results2 = _interopRequireDefault(_Results);

var _poll = __webpack_require__(63);

var _results = __webpack_require__(189);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
	var polls = _ref.polls,
	    results = _ref.results,
	    user = _ref.user;
	var params = _ref2.params;
	return {
		enableRemove: user && polls[params.pollId] && user.uid === polls[params.pollId].uid,
		poll: polls[params.pollId],
		results: results[params.pollId]
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
	var params = _ref3.params;
	return {
		load: function load() {
			var pollId = params.pollId;

			dispatch((0, _poll.listenForPoll)(pollId));
			dispatch((0, _results.listenForResults)(pollId));
		},
		remove: function remove() {
			var pollId = params.pollId;

			dispatch((0, _poll.removePoll)(pollId));
		}
	};
};

var Container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Results2.default);

exports.default = Container;

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(23);

var _FlatButton = __webpack_require__(69);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _FloatingActionButton = __webpack_require__(143);

var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);

var _share = __webpack_require__(244);

var _share2 = _interopRequireDefault(_share);

var _plural = __webpack_require__(243);

var _plural2 = _interopRequireDefault(_plural);

var _Fullscreen = __webpack_require__(572);

var _Fullscreen2 = _interopRequireDefault(_Fullscreen);

var _Page = __webpack_require__(52);

var _Page2 = _interopRequireDefault(_Page);

var _Poll = __webpack_require__(35);

var _Poll2 = _interopRequireDefault(_Poll);

var _Bar = __webpack_require__(575);

var _Bar2 = _interopRequireDefault(_Bar);

var _colors = __webpack_require__(578);

var _Remove = __webpack_require__(579);

var _Remove2 = _interopRequireDefault(_Remove);

__webpack_require__(580);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Results = function (_React$Component) {
	_inherits(Results, _React$Component);

	function Results(props) {
		_classCallCheck(this, Results);

		var _this = _possibleConstructorReturn(this, (Results.__proto__ || Object.getPrototypeOf(Results)).call(this, props));

		_this.state = {};
		return _this;
	}

	_createClass(Results, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.load();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.updateChartData(this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.updateChartData(nextProps);
		}
	}, {
		key: 'updateChartData',
		value: function updateChartData(_ref) {
			var poll = _ref.poll,
			    results = _ref.results;

			if (!(poll && results && results.length)) return;

			var totalVotes = results.reduce(function (total, votes) {
				return total + votes;
			}, 0);

			var percentages = results.map(function (votes) {
				return Math.round(votes / totalVotes * 100);
			});

			var labels = poll.options.map(function (option, i) {
				return option + ' (' + percentages[i] + '%)';
			});

			var barData = labels.map(function (label, i) {
				return {
					label: label,
					value: results[i],
					percent: percentages[i]
				};
			});

			this.setState({
				barData: barData,
				data: {
					labels: labels,
					datasets: [{
						data: results,
						backgroundColor: _colors.colors,
						hoverBackgroundColor: _colors.colors
					}]
				},
				percentages: percentages,
				totalVotes: totalVotes
			});
		}
	}, {
		key: 'render',
		value: function render() {
			if (!(this.props.poll && this.props.results)) {
				return null;
			}

			var _props$poll = this.props.poll,
			    key = _props$poll.key,
			    question = _props$poll.question;


			var pageTitle = '(' + this.state.totalVotes + ') ' + question;

			return _react2.default.createElement(
				_Page2.default,
				{ className: 'results', title: 'Results', pageTitle: pageTitle, showBack: true },
				_react2.default.createElement(
					'p',
					{ className: 'question' },
					question
				),
				this.state.totalVotes ? _react2.default.createElement(
					'div',
					{ className: 'graph' },
					_react2.default.createElement(
						'p',
						{ className: 'votes' },
						(0, _plural2.default)(this.state.totalVotes, 'vote')
					),
					_react2.default.createElement(_Bar2.default, { dataset: this.state.barData })
				) : _react2.default.createElement(
					'div',
					{ className: 'empty' },
					_react2.default.createElement(
						'p',
						null,
						'No votes yet.'
					),
					_react2.default.createElement(
						'p',
						null,
						'Share it with more people using the share button!'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'actions pinned top' },
					_react2.default.createElement(_Fullscreen2.default, { secondary: true })
				),
				_react2.default.createElement(
					'div',
					{ className: 'actions pinned' },
					_react2.default.createElement(
						_FloatingActionButton2.default,
						{
							onClick: function onClick() {
								return _reactRouter.browserHistory.push('/' + key + '/send');
							}
						},
						_react2.default.createElement(_share2.default, null)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'actions' },
					_react2.default.createElement(_FlatButton2.default, {
						label: 'Go vote',
						onClick: function onClick() {
							return _reactRouter.browserHistory.push('/' + key);
						}
					}),
					this.props.enableRemove ? _react2.default.createElement(_Remove2.default, { remove: this.props.remove }) : null
				)
			);
		}
	}]);

	return Results;
}(_react2.default.Component);

exports.default = Results;


Results.propTypes = {
	enableRemove: _propTypes2.default.bool,
	load: _propTypes2.default.func.isRequired,
	poll: _propTypes2.default.instanceOf(_Poll2.default),
	remove: _propTypes2.default.func.isRequired,
	results: _propTypes2.default.arrayOf(_propTypes2.default.number)
};

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Fullscreen;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FloatingActionButton = __webpack_require__(143);

var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);

var _fullscreen = __webpack_require__(573);

var _fullscreen2 = _interopRequireDefault(_fullscreen);

var _screenfull = __webpack_require__(574);

var _screenfull2 = _interopRequireDefault(_screenfull);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Fullscreen() {
	var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	if (!_screenfull2.default.enabled) return null;

	return _react2.default.createElement(
		_FloatingActionButton2.default,
		_extends({
			className: 'fullscreen-button',
			mini: true,
			onClick: function onClick() {
				return _screenfull2.default.toggle();
			}
		}, props),
		_react2.default.createElement(_fullscreen2.default, null)
	);
}

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Bar;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(576);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Bar(_ref) {
	var dataset = _ref.dataset;

	return _react2.default.createElement(
		'div',
		{ className: 'chart bar' },
		dataset.map(function (set, i) {
			return _react2.default.createElement(
				'div',
				{ className: 'set', key: i },
				_react2.default.createElement(
					'div',
					{ className: 'label' },
					set.label
				),
				_react2.default.createElement(
					'div',
					{ className: 'bar' },
					_react2.default.createElement('div', {
						className: 'value value-' + set.percent,
						style: {
							width: set.percent + '%'
						}
					})
				)
			);
		})
	);
}

Bar.propTypes = {
	dataset: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		label: _propTypes2.default.string,
		percent: _propTypes2.default.number
	}))
};

Bar.defaultProps = {
	dataset: []
};

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var colors = exports.colors = ['#aeea00', '#c51162', '#00bfa5', '#64dd17', '#ffab00'];

var backgroundColor = exports.backgroundColor = colors;

var hoverBackgroundColor = exports.hoverBackgroundColor = colors;

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dialog = __webpack_require__(236);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _FlatButton = __webpack_require__(69);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Results = function (_React$Component) {
	_inherits(Results, _React$Component);

	function Results(props) {
		_classCallCheck(this, Results);

		var _this = _possibleConstructorReturn(this, (Results.__proto__ || Object.getPrototypeOf(Results)).call(this, props));

		_this.state = {
			open: false
		};

		_this.handleSubmit = function () {
			_this.setState({ open: false });
			_this.props.remove();
		};
		return _this;
	}

	_createClass(Results, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var actions = [_react2.default.createElement(_FlatButton2.default, {
				label: 'Cancel',
				onTouchTap: function onTouchTap() {
					_this2.setState({ open: false });
				}
			}), _react2.default.createElement(_FlatButton2.default, {
				label: 'Delete',
				onTouchTap: this.handleSubmit,
				primary: true
			})];

			return _react2.default.createElement(
				'div',
				{ className: 'action center remove' },
				_react2.default.createElement(_FlatButton2.default, {
					label: 'Delete poll',
					onClick: function onClick() {
						_this2.setState({ open: true });
					},
					secondary: true,
					style: { color: 'red' }
				}),
				_react2.default.createElement(
					_Dialog2.default,
					{
						actions: actions,
						modal: true,
						open: this.state.open,
						title: 'Delete poll?'
					},
					'This action cannot be undone. Permanently delete poll?'
				)
			);
		}
	}]);

	return Results;
}(_react2.default.Component);

exports.default = Results;


Results.propTypes = {
	remove: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = __webpack_require__(36);

var _Send = __webpack_require__(583);

var _Send2 = _interopRequireDefault(_Send);

var _poll = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
	var polls = _ref.polls;
	var params = _ref2.params;
	return {
		poll: polls[params.pollId]
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
	var params = _ref3.params;
	return {
		load: function load() {
			var pollId = params.pollId;

			dispatch((0, _poll.listenForPoll)(pollId));
		}
	};
};

var Container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Send2.default);

exports.default = Container;

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(23);

var _Divider = __webpack_require__(233);

var _Divider2 = _interopRequireDefault(_Divider);

var _List = __webpack_require__(95);

var _FlatButton = __webpack_require__(69);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _mailOutline = __webpack_require__(584);

var _mailOutline2 = _interopRequireDefault(_mailOutline);

var _share = __webpack_require__(244);

var _share2 = _interopRequireDefault(_share);

var _FacebookService = __webpack_require__(585);

var _FacebookService2 = _interopRequireDefault(_FacebookService);

var _Page = __webpack_require__(52);

var _Page2 = _interopRequireDefault(_Page);

var _Poll = __webpack_require__(35);

var _Poll2 = _interopRequireDefault(_Poll);

__webpack_require__(586);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Send = function (_React$Component) {
	_inherits(Send, _React$Component);

	function Send() {
		_classCallCheck(this, Send);

		return _possibleConstructorReturn(this, (Send.__proto__ || Object.getPrototypeOf(Send)).apply(this, arguments));
	}

	_createClass(Send, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.load();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.facebook = (0, _FacebookService2.default)();
		}
	}, {
		key: 'handleMailClick',
		value: function handleMailClick() {
			var subj = encodeURIComponent(this.props.poll.question);
			var body = encodeURIComponent('Click here to vote:\n\n' + this.props.poll.url + '\n\n\u2014\nCreate your own polls on\nhttps://sendpoll.com');

			location.href = 'mailto:?subject=' + subj + '&body=' + body;
		}
	}, {
		key: 'handleFacebookClick',
		value: function handleFacebookClick() {
			var _this2 = this;

			this.facebook.then(function (FB) {
				FB.ui({
					method: 'share',
					mobile_iframe: true,
					href: 'https://sendpoll.com/' + _this2.props.poll.id,
					quote: 'Vote for "' + _this2.props.poll.question + '"'
				});
			});
		}
	}, {
		key: 'handleShareClick',
		value: function handleShareClick() {
			navigator.share({
				title: 'Sendpoll',
				text: 'Vote for "' + this.props.poll.question + '"',
				url: this.props.poll.url
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			if (!this.props.poll) {
				return null;
			}

			return _react2.default.createElement(
				_Page2.default,
				{ className: 'send', title: 'Send' },
				_react2.default.createElement(
					'p',
					{ className: 'question' },
					this.props.poll.question
				),
				_react2.default.createElement('textarea', {
					className: 'url',
					defaultValue: this.props.poll.url,
					onClick: Send.handleClickSelection,
					readOnly: true
				}),
				_react2.default.createElement(
					'ol',
					{ className: 'list numbered' },
					_react2.default.createElement(
						'li',
						null,
						'Tap the link and copy'
					),
					_react2.default.createElement(
						'li',
						null,
						'Paste to SMS, mail or social app'
					),
					_react2.default.createElement(
						'li',
						null,
						'Share with your friends'
					)
				),
				_react2.default.createElement(_Divider2.default, { style: { marginTop: '2em' } }),
				navigator.share !== undefined ? _react2.default.createElement(
					_List.List,
					null,
					_react2.default.createElement(_List.ListItem, {
						leftIcon: _react2.default.createElement(_share2.default, null),
						primaryText: 'Send\u2026',
						onClick: function onClick() {
							return _this3.handleShareClick();
						}
					})
				) : _react2.default.createElement(
					_List.List,
					null,
					_react2.default.createElement(_List.ListItem, {
						leftIcon: _react2.default.createElement(_mailOutline2.default, null),
						primaryText: 'Send with e-mail',
						onClick: function onClick() {
							return _this3.handleMailClick();
						}
					}),
					_react2.default.createElement(_List.ListItem, {
						leftIcon: _react2.default.createElement(_share2.default, null),
						primaryText: 'Send with Facebook',
						onClick: function onClick() {
							return _this3.handleFacebookClick();
						}
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'actions' },
					_react2.default.createElement(
						'div',
						{ className: 'p' },
						_react2.default.createElement(_FlatButton2.default, {
							label: 'See your polls',
							onClick: function onClick() {
								return _reactRouter.browserHistory.push('/polls');
							}
						})
					)
				)
			);
		}
	}], [{
		key: 'handleClickSelection',
		value: function handleClickSelection(event) {
			event.target.focus();
			event.target.setSelectionRange(0, 9999);
		}
	}]);

	return Send;
}(_react2.default.Component);

exports.default = Send;


Send.propTypes = {
	load: _propTypes2.default.func.isRequired,
	poll: _propTypes2.default.instanceOf(_Poll2.default)
};

Send.defaultProps = {
	poll: null
};

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = init;
/* global FB */
var done = false;

function init() {
	if (done) {
		return Promise.resolve();
	}

	return new Promise(function (resolve) {
		window.fbAsyncInit = function () {
			FB.init({
				appId: {"facebook":"1308684189194545","analytics":"UA-88910082-1","sentry":"https://bc46ef7cef124a6cae92216ca285790a@sentry.io/122103"}.facebook,
				xfbml: true,
				version: 'v2.8'
			});
			FB.AppEvents.logPageView();

			done = true;
			resolve(FB);
		};

		/* eslint-disable */
		(function (d, s, id) {
			var js,
			    fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) {
				return;
			}
			js = d.createElement(s);js.id = id;
			js.src = "//connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		})(document, 'script', 'facebook-jssdk');
		/* eslint-enable */
	});
}

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = __webpack_require__(36);

var _Settings = __webpack_require__(589);

var _Settings2 = _interopRequireDefault(_Settings);

var _poll = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
	var polls = _ref.polls;
	var params = _ref2.params;
	return {
		poll: polls[params.pollId]
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
	var params = _ref3.params;
	return {
		load: function load() {
			dispatch((0, _poll.listenForPoll)(params.pollId));
		},
		update: function update(values) {
			dispatch((0, _poll.update)(params.pollId, values));
		}
	};
};

var Container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Settings2.default);

exports.default = Container;

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _List = __webpack_require__(95);

var _Subheader = __webpack_require__(221);

var _Subheader2 = _interopRequireDefault(_Subheader);

var _Toggle = __webpack_require__(590);

var _Toggle2 = _interopRequireDefault(_Toggle);

var _Page = __webpack_require__(52);

var _Page2 = _interopRequireDefault(_Page);

var _Poll = __webpack_require__(35);

var _Poll2 = _interopRequireDefault(_Poll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = function (_React$Component) {
	_inherits(Settings, _React$Component);

	function Settings(props) {
		_classCallCheck(this, Settings);

		var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

		_this.handleToggle = function (event, isLoginRequired) {
			_this.props.update({ isLoginRequired: isLoginRequired });
		};
		return _this;
	}

	_createClass(Settings, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.load();
		}
	}, {
		key: 'render',
		value: function render() {
			if (!this.props.poll) {
				return null;
			}

			var poll = this.props.poll;


			return _react2.default.createElement(
				_Page2.default,
				{ className: 'settings', title: 'Settings' },
				_react2.default.createElement(
					_List.List,
					null,
					_react2.default.createElement(
						_Subheader2.default,
						null,
						'Settings'
					),
					_react2.default.createElement(_List.ListItem, {
						primaryText: 'Require login to vote',
						rightToggle: _react2.default.createElement(_Toggle2.default, {
							onToggle: this.handleToggle,
							toggled: poll.isLoginRequired
						}),
						secondaryText: 'Ensures that only people registered can vote',
						secondaryTextLines: 2
					})
				)
			);
		}
	}]);

	return Settings;
}(_react2.default.Component);

exports.default = Settings;


Settings.propTypes = {
	load: _propTypes2.default.func.isRequired,
	poll: _propTypes2.default.instanceOf(_Poll2.default),
	update: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reactRedux = __webpack_require__(36);

var _Vote = __webpack_require__(593);

var _Vote2 = _interopRequireDefault(_Vote);

var _poll = __webpack_require__(63);

var _vote = __webpack_require__(600);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(_ref, _ref2) {
	var polls = _ref.polls,
	    vote = _ref.vote;
	var params = _ref2.params;
	return {
		poll: polls[params.pollId],
		vote: vote
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
	var params = _ref3.params;
	return {
		load: function load() {
			dispatch((0, _poll.listenForPoll)(params.pollId));
			dispatch((0, _vote.getVote)(params.pollId));
		},
		submit: function submit(option) {
			dispatch((0, _vote.castVote)(params.pollId, option));
		}
	};
};

var Container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Vote2.default);

exports.default = Container;

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(23);

var _FlatButton = __webpack_require__(69);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _RadioButton = __webpack_require__(594);

var _RaisedButton = __webpack_require__(234);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _Page = __webpack_require__(52);

var _Page2 = _interopRequireDefault(_Page);

var _Poll = __webpack_require__(35);

var _Poll2 = _interopRequireDefault(_Poll);

var _Splash = __webpack_require__(215);

var _Splash2 = _interopRequireDefault(_Splash);

__webpack_require__(598);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Vote = function (_React$Component) {
	_inherits(Vote, _React$Component);

	function Vote(props) {
		_classCallCheck(this, Vote);

		var _this = _possibleConstructorReturn(this, (Vote.__proto__ || Object.getPrototypeOf(Vote)).call(this, props));

		_this.state = {
			selected: props.vote && props.vote.option
		};

		_this.handleChange = function (event, value) {
			_this.setState({ selected: value });
		};

		_this.handleSubmit = function () {
			_this.props.submit(_this.state.selected);
		};
		return _this;
	}

	_createClass(Vote, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.load();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.vote) {
				this.setState({
					hasVoted: true,
					selected: nextProps.vote.option
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var poll = this.props.poll;


			if (!poll) {
				return _react2.default.createElement(_Splash2.default, null);
			}

			return _react2.default.createElement(
				_Page2.default,
				{ className: 'vote', title: 'Vote' },
				_react2.default.createElement(
					'p',
					{ className: 'question' },
					poll.question
				),
				_react2.default.createElement(
					_RadioButton.RadioButtonGroup,
					{
						className: 'options',
						name: 'options',
						onChange: this.handleChange,
						valueSelected: this.state.selected
					},
					poll.options.map(function (label, i) {
						return _react2.default.createElement(_RadioButton.RadioButton, { key: i, value: i, label: label });
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'actions' },
					_react2.default.createElement(_RaisedButton2.default, {
						label: 'Vote',
						onClick: this.handleSubmit
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'actions' },
					this.state.hasVoted ? _react2.default.createElement(_FlatButton2.default, {
						label: 'See results',
						onClick: function onClick() {
							return _reactRouter.browserHistory.push('/' + poll.key + '/results');
						}
					}) : null
				)
			);
		}
	}]);

	return Vote;
}(_react2.default.Component);

exports.default = Vote;


Vote.propTypes = {
	load: _propTypes2.default.func.isRequired,
	poll: _propTypes2.default.instanceOf(_Poll2.default),
	submit: _propTypes2.default.func.isRequired,
	vote: _propTypes2.default.shape({
		option: _propTypes2.default.number
	})
};

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.castVote = exports.getVote = undefined;

var _reduxActions = __webpack_require__(34);

var _reactRouter = __webpack_require__(23);

var _VoteService = __webpack_require__(601);

var _VoteService2 = _interopRequireDefault(_VoteService);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = new _VoteService2.default();

var getVote = exports.getVote = (0, _reduxActions.createAction)(_types2.default.VOTE_READ, function (pollId) {
	return service.get(pollId);
});

var castVote = exports.castVote = (0, _reduxActions.createAction)(_types2.default.VOTE_CAST, function (pollId, option) {
	return service.cast(pollId, option).then(function () {
		return _reactRouter.browserHistory.push('/' + pollId + '/vote/success');
	});
});

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AuthService = __webpack_require__(118);

var _AuthService2 = _interopRequireDefault(_AuthService);

var _ResultsService = __webpack_require__(190);

var _ResultsService2 = _interopRequireDefault(_ResultsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VoteService = function () {
	function VoteService() {
		_classCallCheck(this, VoteService);

		this.auth = new _AuthService2.default();
		this.ref = firebase.database().ref();
		this.votesRef = this.ref.child('votes');
		this.results = new _ResultsService2.default();
	}

	_createClass(VoteService, [{
		key: 'cast',
		value: function cast(pollId, option) {
			var _this = this;

			return this.auth.getOrCreateUser().then(function (_ref) {
				var uid = _ref.uid;
				return _this.get(pollId).then(function (vote) {
					return vote && vote.option;
				}).then(function (existing) {
					return Promise.all([_this.results.update(pollId, option, existing), _this.votesRef.child(pollId).child(uid).set({
						option: option,
						ts: firebase.database.ServerValue.TIMESTAMP
					})]);
				});
			});
		}
	}, {
		key: 'get',
		value: function get(pollId) {
			if (!this.auth.currentUser) {
				return Promise.resolve(null);
			}

			var uid = this.auth.currentUser.uid;


			return this.votesRef.child(pollId).child(uid).once('value').then(function (snap) {
				return snap.val();
			});
		}
	}]);

	return VoteService;
}();

exports.default = VoteService;

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Success;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(23);

var _FlatButton = __webpack_require__(69);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _colors = __webpack_require__(73);

var _mood = __webpack_require__(603);

var _mood2 = _interopRequireDefault(_mood);

var _Page = __webpack_require__(52);

var _Page2 = _interopRequireDefault(_Page);

__webpack_require__(604);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Success(_ref) {
	var params = _ref.params;

	return _react2.default.createElement(
		_Page2.default,
		{ className: 'vote success', title: 'Vote Cast!' },
		_react2.default.createElement(
			'p',
			{ className: 'thanks' },
			'Thank you for voting!'
		),
		_react2.default.createElement(
			'p',
			{ className: 'thanks' },
			_react2.default.createElement(_mood2.default, { style: { color: _colors.orange500, width: '60px', height: '60px' } })
		),
		_react2.default.createElement(
			'div',
			{ className: 'actions' },
			_react2.default.createElement(_FlatButton2.default, {
				label: 'See results',
				onClick: function onClick() {
					return _reactRouter.browserHistory.replace('/' + params.pollId + '/results');
				},
				primary: true
			})
		),
		_react2.default.createElement(
			'div',
			{ className: 'actions' },
			_react2.default.createElement(_FlatButton2.default, {
				label: 'Create your own poll',
				onClick: function onClick() {
					return _reactRouter.browserHistory.replace('/create');
				}
			})
		)
	);
}

Success.propTypes = {
	params: _propTypes2.default.shape({
		pollId: _propTypes2.default.string.isRequired
	}).isRequired
};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.update = exports.removePoll = exports.createPoll = undefined;
exports.listenForPoll = listenForPoll;

var _reactRouter = __webpack_require__(23);

var _reduxActions = __webpack_require__(34);

var _PollService = __webpack_require__(367);

var _PollService2 = _interopRequireDefault(_PollService);

var _types = __webpack_require__(28);

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = new _PollService2.default();

var createPoll = exports.createPoll = (0, _reduxActions.createAction)(_types2.default.POLL_CREATE, function (data) {
	return service.create(data).then(function (key) {
		_reactRouter.browserHistory.push('/' + key + '/send');
	});
});

var removePoll = exports.removePoll = (0, _reduxActions.createAction)(_types2.default.POLL_REMOVE, function (pollId) {
	return service.remove(pollId).then(function () {
		_reactRouter.browserHistory.replace('/polls');
		return { key: pollId };
	});
});

function listenForPoll(pollId) {
	return function (dispatch, getState) {
		if (pollId in getState().polls) return;

		service.listen(pollId, function (poll) {
			dispatch({ type: _types2.default.POLL_UPDATED, payload: poll });
		});
	};
}

var update = exports.update = (0, _reduxActions.createAction)(_types2.default.POLL_UPDATE, function (pollId, values) {
	return service.update(pollId, values);
});

/***/ })

},[249]);


// WEBPACK FOOTER //
// app-850707f96571c50366d7.js